import React, { useState, useEffect } from 'react';
import { Routes, Route, useNavigate } from 'react-router-dom';

import Landing from './Components/Landing/Landing';
import FilmScoring from './Components/FilmScoring/FilmScoring';
import Placements from './Components/Placements/Placements';
import Musical from './Components/Musical/Musical';
import Contact from './Components/Contact/Contact';
import Portal from './Components/Portal/Portal';
import About from './Components/About/About';
import firebase from './firebase';

import './App.css';

if(firebase === '') console.log(null);

const width = 900;

const App = () => {
	const [ dimensions, setDimensions ] = useState({width:0,height:0});

	// HANDLES PAGE RESIZING
		useEffect(()=>{
			setDimensions({height:document.documentElement.clientHeight,
							width:document.documentElement.clientWidth});
			window.addEventListener('resize', init);
			return () => {
				window.removeEventListener('resize', init);
			}
		},[]);
		function init() {
			setDimensions({height:document.documentElement.clientHeight,
							width:document.documentElement.clientWidth});
		}

	const navigate = useNavigate();

	let inputWidth = width;
	if(dimensions.width < 940) inputWidth = 700;
	if(dimensions.width < 740) inputWidth = dimensions.width-20;
	return(
		<Routes>
				<Route path='/' exact element={ <Landing navigate={navigate} width={inputWidth} dimensions={dimensions} /> } />
				<Route path='/about' exact element={ <About navigate={navigate} width={inputWidth} dimensions={dimensions} /> } />
				<Route path='/film' exact element={ <FilmScoring navigate={navigate} width={inputWidth} dimensions={dimensions} /> } />
				<Route path='/placements' exact element={ <Placements navigate={navigate} width={inputWidth} dimensions={dimensions} /> } />
				<Route path='/musical' exact element={ <Musical navigate={navigate} width={inputWidth} dimensions={dimensions} /> } />
				<Route path='/contact' exact element={ <Contact navigate={navigate} width={inputWidth} dimensions={dimensions} /> } />

				<Route path='/portal' exact element={ <Portal navigate={navigate} width={inputWidth} dimensions={dimensions} /> } />

		</Routes>
	)
}

export default App;